import {createAction} from '@reduxjs/toolkit'
const validateURL = createAction<{importURL: string}>('validateURL')
const validateURLFailure = createAction<string>('validateURLFailure')
const validateURLSuccess = createAction<{
  auth_provider: string
  auth_url: string
}>('validateURLSuccess')

export {validateURL, validateURLFailure, validateURLSuccess}
